import React from "react";
import { Auth } from 'aws-amplify';
import * as Icon from "react-bootstrap-icons";

class Logout extends React.Component {

    logout = async() => {
        try {
            await Auth.signOut();
            window.location.href = "/";
        } catch (error) {
            console.log('error signing out: ', error);
        }
    }

    render() {
        return (
            <div className="item">
                <div onClick={this.logout}><div className="menu_icon"><Icon.BoxArrowLeft /></div>Logout</div>
            </div>
        );
    }
}

export default Logout;